import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.resize();
  }

  resize() {
    const lines = (this.element.value.match(/\n/g) || '').length + 1
    this.element.style.height = (lines*1.25 + 2) + "em";
  }

}
